
// Action Types
export const SET_LOCALE_MESSAGES = 'SET_LOCALE_MESSAGES';
import AppConfigService from '../services/AppConfigService';
import EventDispatcher from "../framework/EventDispatcher";
// Reducer
export default function reducer(state = {}, action = {}) {
	switch (action.type) {
			case EventDispatcher.successAction(SET_LOCALE_MESSAGES):
				return {
					...state,
					messages: action.data.messages,
					error: null
				};
				break;
				default:
				return state;
			}
	
}

// Actions
export function setLocaleMessages(messages) {
	return dispatch => {
		EventDispatcher.loading(dispatch, SET_LOCALE_MESSAGES);
		AppConfigService.loadConfigFile(messages)
			.then(messages => {
				if (!!messages) {
					EventDispatcher.success(dispatch, SET_LOCALE_MESSAGES, {messages});
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, SET_LOCALE_MESSAGES, error);
			});
	}
}



// WEBPACK FOOTER //
// ./src/opencell/actions/PageModule.js